var map = {
	"./icon-boardjf.png": "bf02",
	"./icon-boardjfBlue.png": "0bce",
	"./icon-material.png": "f01b",
	"./icon-materialBlue.png": "6e38",
	"./icon-order.png": "67d0",
	"./icon-orderBlue.png": "fe2a",
	"./icon-package.png": "0f8a",
	"./icon-packageBlue.png": "4d09",
	"./icon-promise.png": "e47d",
	"./icon-promiseBlue.png": "134a",
	"./icon-quotation.png": "8b5a",
	"./icon-quotationBlue.png": "eb07",
	"./icon-schedule.png": "3522",
	"./icon-scheduleBlue.png": "8bff",
	"./icon-signedorder.png": "0616",
	"./icon-signedorderBlue.png": "772e",
	"./icon-template.png": "67c7",
	"./icon-templateBlue.png": "8ca5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d50e";